import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import Vue from 'vue'
const state = {
  //试题id 预览一道试题时查询 使用
  exercisesId: '',
  //预览多道试题时查询试题条件
  selectExercisesSC: {},
  // start
  givingHistoryId: '',
  teachingPlanId: '',
  teachingPlanHourId: '',
  teachingPlanHourProcessId: ''
  // end
}

const actions = {
  setExercisesId({commit},id){
    commit('SET_EXERCISES_ID', id);
  },
  setSelectExercisesSC({commit}, param){
    commit('SET_SELECT_EXERCISES_SC', param);
  }
}

const getters = {}

const mutations = {
  ['SET_EXERCISES_ID'](state, id) {
    Vue.set(state, 'exercisesId', id);
  },
  ['SET_SELECT_EXERCISES_SC'](state, param) {
    Vue.set(state, 'selectExercisesSC', param);
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/answerquestion.js